module.exports = __webpack_public_path__ + "img/web-15.599deb2e.gif";